import { makeAutoObservable } from "mobx"

interface NestedMenuItemStoreProps {
   ContainerProps: React.HTMLAttributes<HTMLElement> & React.RefAttributes<HTMLElement | null>
   containerRef: React.MutableRefObject<HTMLDivElement | null>
   menuContainerRef: React.MutableRefObject<HTMLDivElement | null>
   parentMenuOpen: boolean
}

export default class NestedMenuItemStore {
   isSubMenuOpen = false
   sp

   constructor(sp: NestedMenuItemStoreProps) {
      this.sp = sp
      makeAutoObservable(this)
   }

   get open() {
      return this.isSubMenuOpen && this.sp.parentMenuOpen
   }

   handleMouseEnter = (e: React.MouseEvent<HTMLElement>) => {
      this.isSubMenuOpen = true

      if (this.sp.ContainerProps.onMouseEnter) {
         this.sp.ContainerProps.onMouseEnter(e)
      }
   }

   handleMouseLeave = (e: React.MouseEvent<HTMLElement>) => {
      this.isSubMenuOpen = false

      if (this.sp.ContainerProps.onMouseLeave) {
         this.sp.ContainerProps.onMouseLeave(e)
      }
   }

   // Check if any immediate children are active
   isSubmenuFocused = () => {
      const active = this.sp.containerRef.current?.ownerDocument.activeElement ?? null;
      if (this.sp.menuContainerRef.current) {
         for (const child of this.sp.menuContainerRef.current.children) {
            if (child === active) {
               return true
            }
         }
      }

      return false
   };

   handleFocus = (e: React.FocusEvent<HTMLElement>) => {
      if (e.target === this.sp.containerRef.current) {
         this.isSubMenuOpen = false
      }

      if (this.sp.ContainerProps.onFocus) {
         this.sp.ContainerProps.onFocus(e)
      }
   };

   handleKeyDown = (e: React.KeyboardEvent) => {
      if (e.key === 'Escape') {
         return
      }

      if (this.isSubmenuFocused()) {
         e.stopPropagation()
      }
   }

   closeSubMenu = () => {
      this.isSubMenuOpen = false
   }

}

